<template>
  <span
    v-if="label"
    class="payment-discount-badge"
    :class="{ featured }"
    aria-label="Discount"
  >
    <img
      :src="featured ? discountTicketHighlight : discountTicket"
      alt=""
      aria-hidden="true"
    >
    <span>{{ label }}</span>
  </span>
</template>

<script setup>
import discountTicket from '@/img/recharge/discount-ticket.svg'
import discountTicketHighlight from '@/img/recharge/discount-ticket-highlight.svg'

defineProps({
  label: {
    type: String,
    default: '',
  },
  featured: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.payment-discount-badge {
  position: absolute;
  top: -4px;
  right: -6px;
  z-index: 2;
  width: 83px;
  height: 18px;
  pointer-events: none;
}

.payment-discount-badge img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.payment-discount-badge span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 4px;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  line-height: 1;
  font-weight: 600;
  white-space: nowrap;
  background: linear-gradient(90deg, #FC1192 0%, #FE8F19 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  transform: translateY(1px);
}

.payment-discount-badge.featured {
  top: -13px;
  width: 97px;
  height: 28.403px;
}

.payment-discount-badge.featured span {
  padding: 0 4px 0 22px;
  color: #ffffff;
  background: none;
  -webkit-text-fill-color: currentColor;
  transform: translateY(4px);
}
</style>
